/* BETWEEN SECONDS · Destaque de produto — entrada das peças no scroll. */
(function () {
  function init() {
    document.querySelectorAll('[data-bsf]:not([data-bsf-init])').forEach(function (root) {
      root.setAttribute('data-bsf-init', '1');
      var items = [].slice.call(root.querySelectorAll('[data-bsf-item]'));
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) { items.forEach(function (it) { it.classList.add('is-in'); }); return; }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { threshold: .18 });
      items.forEach(function (it) { io.observe(it); });
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
